import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

/**
 * @class Works like tables in SQL.
 */
export class Containers {

  /**
   * Loads all containers inside of a bucket.
   * @param {number} bucket_id The bucket ID, where the containers are located.
   */
  static async load(bucket_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          bucket: bucket_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Get just one single container item by his id.
   * @param {number} container_id The container ID, which should be retrieved.
   */
  static async get(container_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          container: container_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Add a new container inside of a bucket.
   * @param {number} bucket_id The bucket ID, where the new container should be created.
   * @param {string} container_name The new container name.
   */
  static async add(bucket_id, container_name) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          bucket: bucket_id,
          name: container_name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Edit an exisiting container by providing a new name and exisiting container id.
   * @param {number} container_id The container ID, which should be updated.
   * @param {string} container_name The new container name.
   * @param {boolean} exportable If true, it makes the container exportable. Default: true
   */
  static async edit(container_id, container_name, exportable) {
    if (exportable === undefined) {
      exportable = true;
    }
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: container_id,
          name: container_name,
          exportable: exportable
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Delete a exisiting container by his id.
   * @param {number} container_id The container ID, which should be updated.
   */
  static async delete(container_id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/container/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: container_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
